var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var StarIcon = function (_a) {
    var _b = _a.filled, filled = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    return (_jsx("svg", __assign({ className: "star-icon ".concat(size, " ").concat(filled ? 'filled' : ''), onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, viewBox: "0 0 24 24" }, { children: _jsx("path", { fill: filled ? 'currentColor' : 'none', stroke: "currentColor", d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" }) })));
};
export default StarIcon;
